import ProfileApi from '../ProfileApi';
import { UserProfile } from "../models/profile";

export function updateProfile(profile: UserProfile) {
    return ProfileApi.update(profile);
}
